import React, { useState, useEffect } from 'react';
import {
  Container, Typography, Card, CardContent, Grid, Button, TextField,
  CircularProgress, Alert, Box, Dialog, DialogTitle, DialogContent,
  DialogActions
} from '@mui/material';

function InscricaoCurso() {
  const [cursos, setCursos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [selectedCurso, setSelectedCurso] = useState(null);
  const [form, setForm] = useState({ nome_externo: '', email_externo: '', telefone_externo: '' });
  const [inscrevendo, setInscrevendo] = useState(false);
  const [sucesso, setSucesso] = useState('');

  const API = process.env.REACT_APP_API_URL || 'https://api.conectachurch.com.br';

  useEffect(() => {
    const carregar = async () => {
      try {
        const res = await fetch(`${API}/cursos/`);
        const data = await res.json();
        setCursos(Array.isArray(data) ? data.filter(c => c.status === 'aberto' || c.status === 'andamento') : []);
      } catch {
        setErro('Erro ao carregar cursos');
      }
      setLoading(false);
    };
    carregar();
  }, []);

  const inscrever = async () => {
    if (!form.nome_externo.trim()) { setErro('Nome é obrigatório'); return; }
    if (!form.email_externo.trim()) { setErro('Email é obrigatório'); return; }
    setInscrevendo(true);
    setErro('');
    try {
      const res = await fetch(`${API}/cursos/${selectedCurso.id}/inscricoes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || 'Erro ao inscrever');
      }
      setSucesso(`Inscrição realizada com sucesso no curso "${selectedCurso.titulo}"!`);
      setSelectedCurso(null);
      setForm({ nome_externo: '', email_externo: '', telefone_externo: '' });
    } catch (err) {
      setErro(err.message);
    }
    setInscrevendo(false);
  };

  if (loading) return <Container sx={{ py: 8, textAlign: 'center' }}><CircularProgress /></Container>;

  return (
    <Container maxWidth="md" sx={{ py: { xs: 2, md: 6 }, px: { xs: 1, md: 2 } }}>
      <Typography variant="h3" sx={{ fontWeight: 800, mb: 1, textAlign: 'center', fontSize: { xs: '1.5rem', md: '2.5rem' } }}>
        Inscreva-se em um Curso
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4, textAlign: 'center' }}>
        Preencha seus dados e escolha o curso desejado
      </Typography>

      {sucesso && <Alert severity="success" sx={{ mb: 3 }}>{sucesso}</Alert>}
      {erro && <Alert severity="error" sx={{ mb: 3 }}>{erro}</Alert>}

      {cursos.length === 0 ? (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h6" color="text.secondary">Nenhum curso disponível no momento</Typography>
        </Box>
      ) : (
        <Grid container spacing={3}>
          {cursos.map(curso => (
            <Grid item xs={12} sm={6} key={curso.id}>
              <Card sx={{ cursor: 'pointer', '&:hover': { boxShadow: 6 } }} onClick={() => setSelectedCurso(curso)}>
                <CardContent>
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>{curso.titulo}</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {curso.descricao?.slice(0, 120)}...
                  </Typography>
                  <Box sx={{ mt: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    {curso.data_inicio && <Typography variant="caption">Início: {curso.data_inicio}</Typography>}
                    {curso.local && <Typography variant="caption">Local: {curso.local}</Typography>}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      <Dialog open={!!selectedCurso} onClose={() => setSelectedCurso(null)} maxWidth="sm" fullWidth>
        <DialogTitle>Inscrição - {selectedCurso?.titulo}</DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Nome completo"
              value={form.nome_externo}
              onChange={e => setForm(f => ({...f, nome_externo: e.target.value}))}
              fullWidth
              required
            />
            <TextField
              label="Email"
              type="email"
              value={form.email_externo}
              onChange={e => setForm(f => ({...f, email_externo: e.target.value}))}
              fullWidth
              required
            />
            <TextField
              label="Telefone"
              value={form.telefone_externo}
              onChange={e => setForm(f => ({...f, telefone_externo: e.target.value}))}
              fullWidth
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSelectedCurso(null)}>Cancelar</Button>
          <Button variant="contained" onClick={inscrever} disabled={inscrevendo}>
            {inscrevendo ? 'Inscrevendo...' : 'Confirmar Inscrição'}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default InscricaoCurso;
